/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash e71cc77f1aa79411f47c53c49cf46494 */

import { ConcreteRequest } from "relay-runtime";

export type EditNewslettersInput = {
    userServiceId: string;
    emailToken?: string | null | undefined;
    promotional?: boolean | null | undefined;
    favoriteSearches?: boolean | null | undefined;
    favoriteDealers?: boolean | null | undefined;
    trade?: boolean | null | undefined;
    smsOptin?: boolean | null | undefined;
    orderFeedbackMailOptin?: boolean | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type subscribeUserMutationVariables = {
    input: EditNewslettersInput;
};
export type subscribeUserMutationResponse = {
    readonly editNewsletters: {
        readonly clientMutationId: string | null;
    } | null;
};
export type subscribeUserMutation = {
    readonly response: subscribeUserMutationResponse;
    readonly variables: subscribeUserMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "EditNewslettersPayload",
            "kind": "LinkedField",
            "name": "editNewsletters",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "subscribeUserMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutations",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "subscribeUserMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "ferrum/352.0.0-2022-02-11T14:31:47.735Z/subscribeUserMutation",
            "metadata": {},
            "name": "subscribeUserMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'c9543e77c781df16904396e3a1064187';
export default node;
